import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

//Para los select
// import MenuItem from '@material-ui/core/MenuItem';
// import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Select from 'react-select';

export default class ProjectInfo extends Component {


  constructor(props)
  {
    super(props);
    //Bindings
    this.handleChangePMCountry=this.handleChangePMCountry.bind(this);
  }
  
  static propTypes = {

  };

  state = {
  };

  handleChangePMCountry(val){
   this.props.handleChange({target:{value:val.value,id:'p_m_company_country'}}) 
  }
  
  getValueCountry(opts, id) {
    let realValue = opts.find(o => o.value === id);
    return realValue;
  }


  render() {

    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Project Information
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="name"
              name="name"
              label="Name"
              fullWidth
              autoComplete="pname"
              value={this.props.project.name}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.name}
              helperText={this.props.errores.project.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="number"
              name="number"
              label="Number"
              fullWidth
              autoComplete="pnumber"
              value={this.props.project.number || ''}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.number}
              helperText={this.props.errores.project.number}
            />
          </Grid>
          <Grid item xs={12}  >
            <TextField
              style={{width: '100%'}}
              id="description"
              label="Description"
              multiline
              rows="4"
              margin="normal"
              value={this.props.project.description}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.description}
              helperText={this.props.errores.project.description}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              style={{width: '90%'}}
              id="kod"
              label="Estimated Kick-Off Date"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              value={this.props.project.kod}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.kod}
              helperText={this.props.errores.project.kod}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              style={{width: '90%'}}
              id="ecd"
              label="Estimated Completion Date"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              value={this.props.project.ecd}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.ecd}
              helperText={this.props.errores.project.ecd}
            />
          </Grid>
          <Grid item xs={12} >
            <Typography variant="h6" gutterBottom>
              Construction Site
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="company"
              name="company"
              label="General Contractor"
              fullWidth
              autoComplete="pCompany"
              value={this.props.project.company}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.company}
              helperText={this.props.errores.project.company}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <div >
              <InputLabel htmlFor="p_m_company_country" style={{marginRight:'10px'}}>Country</InputLabel>
              <Select
                id="p_m_company_country"
                name="p_m_company_country"
                value={this.getValueCountry(this.props.countries,this.props.project.p_m_company_country)}
                onChange={this.handleChangePMCountry}
                isDisabled={this.props.reviewActive}
                error={this.props.errores.project.p_m_company_country}
                errorText={this.props.errores.project.p_m_company_country}
                helperText={this.props.errores.project.p_m_company_country}
                options={this.props.countries}
                styles={{control: (provided,state) => (this.props.errores.project.p_m_company_country ? {...provided,borderColor: 'red', } : provided)}}
              >
              </Select>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
             <TextField
              id="p_m_company_state"
              name="p_m_company_state"
              label="State"
              fullWidth
              autoComplete="pState"
              value={this.props.project.p_m_company_state}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.p_m_company_state}
              helperText={this.props.errores.project.p_m_company_state}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="p_m_company_city"
              name="p_m_company_city"
              label="City"
              fullWidth
              autoComplete="pCity"
              value={this.props.project.p_m_company_city}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.p_m_company_city}
              helperText={this.props.errores.project.p_m_company_city}
            />
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/ProjectInfo.js